import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 選択可能な企業一覧
 *
 * 選択可能な企業データの一覧を返す
 */
export class SelectableCompany implements APIRequest<Monitaro.SelectableCompanyResponse> {
  response: Monitaro.SelectableCompanyResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/companies/selectable`
  }
}

/**
 * 企業一覧
 *
 * 企業データの一覧を返す
 */
export class FetchCompany implements APIRequest<Monitaro.FetchCompanyResponse> {
  response: Monitaro.FetchCompanyResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/companies`
  }
}

/**
 * 企業データの取得
 *
 * 指定されたIDの企業情報を返す
 */
export class GetCompany implements APIRequest<Monitaro.GetCompanyResponse> {
  response: Monitaro.GetCompanyResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(company: string) {
    this.path = `/companies/${company}`
  }
}
